import { FormConfigBuilder } from 'components/form-builder/FormConfigBuilder';
import { validationLatitudeLongitude } from 'validation-latitude-longitude';
import { FormFieldCustomComponentTypes } from 'constants/FormFieldCustomComponentTypes';
import { requiredNumericField } from 'components/form-builder/form-validation/validationNumericField';
import ChangeOrdinal from 'pages/mission/components/mission-form/grid/ChangeOrdinal';
import { Point } from 'models/mission/Point';
import {
    validationLat,
    validationLong,
} from 'components/form-builder/form-validation/validationLatLong';

// eslint-disable-next-line no-unused-vars
const formConfig = (methods = null, watch = null, mode) =>
    new FormConfigBuilder(
        [
            {
                componentType: FormFieldCustomComponentTypes.CustomNumericField,
                attribute: 'ordinal',
                decimalScale: 0,
                // hideCondition: true,
                // validations: [requiredNumericField],
                list: true,
            },
            {
                componentType: 'custom',
                attribute: 'up',
                hideCondition: true,
                list: {
                    maxWidth: 60,
                    renderCell: params => (
                        <ChangeOrdinal
                            {...params}
                            data={methods?.getValues()}
                            slice={'mission'}
                        />
                    ),
                },
            },
            {
                componentType: 'custom',
                attribute: 'down',
                hideCondition: true,
                list: {
                    maxWidth: 60,
                    renderCell: params => (
                        <ChangeOrdinal
                            {...params}
                            data={methods?.getValues()}
                            slice={'mission'}
                        />
                    ),
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.CustomAutoComplete,
                attribute: 'type',
                title: 'Command Type',
                optionConfig: {
                    key: 'buttonType',
                    value: 'type',
                    label: 'type',
                },
                async: {
                    url: '/public/guided-commands/types',
                },
                list: true,
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'p1',
                minWidth: 90,
                list: {
                    editable: true,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'p2',
                list: {
                    editable: true,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'p3',
                list: {
                    editable: true,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'p4',
                list: {
                    editable: true,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.CustomNumericField,
                attribute: 'lat',
                decimalScale: 5,
                allowNegative: true,
                validations: [validationLat({ required: false })],
                list: {
                    editable: true,
                    minWidth: 80,
                    preProcessEditCellProps: params => {
                        const hasNumber = new RegExp(
                            '^[-+]?[0-9]*[.,]?[0-9]+(?:[eE][-+]?[0-9]+)?$',
                        ).test(params.props.value);
                        const hasLatitude =
                            validationLatitudeLongitude.latitude(
                                params.props.value,
                            );

                        return {
                            ...params.props,
                            error: !hasNumber || !hasLatitude,
                        };
                    },
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.CustomNumericField,
                attribute: 'lon',
                decimalScale: 5,
                allowNegative: true,
                validations: [validationLong({ required: false })],
                list: {
                    editable: true,
                    minWidth: 80,
                    preProcessEditCellProps: params => {
                        const hasNumber = new RegExp(
                            '^[-+]?[0-9]*[.,]?[0-9]+(?:[eE][-+]?[0-9]+)?$',
                        ).test(params.props.value);
                        const hasLongitude =
                            validationLatitudeLongitude.longitude(
                                params.props.value,
                            );

                        return {
                            ...params.props,
                            error: !hasNumber || !hasLongitude,
                        };
                    },
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.CustomNumericField,
                attribute: 'alt',
                decimalScale: 1,
                // validations: [requiredNumericField],
                list: {
                    editable: true,
                    minWidth: 80,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'grad',
                list: {
                    editable: true,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'distance',
                list: {
                    editable: true,
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'azimuth',
                list: {
                    editable: true,
                },
            },
        ],
        Point,
    );

// eslint-disable-next-line import/no-anonymous-default-export
export default [{ label: ' Mission Point Information', config: formConfig }];
